// A refused Google/Apple sign-in comes back to /signin (or /signup) as
// `?error_code=<code>&provider=<provider>`; the server sends stable codes and the
// client translates them (#865). The first seven are SocialAuth::ERROR_CODES; the
// last three are raised by OmniauthSessionsController itself. A spec pins both
// lists to this one (spec/frontend/oauth_error_codes_spec.rb).
export const OAUTH_ERROR_CODES = [
  "email_missing",
  "email_unverified",
  "email_closed",
  "consent_required",
  "account_blocked",
  "two_factor_required",
  "retry",
  "cancelled",
  "oauth_failed",
  "unexpected",
] as const;

export type OAuthErrorCode = (typeof OAUTH_ERROR_CODES)[number];

export interface OAuthRefusal {
  code: OAuthErrorCode;
  // Brand names are not translated.
  provider: "Google" | "Apple";
  // A `?error=<sentence>` link from before codes existed, still honoured for one
  // release: shown as is, in English.
  legacyMessage: string | null;
}

export function oauthErrorKey(code: string | null | undefined): string {
  const known = (OAUTH_ERROR_CODES as readonly string[]).includes(code ?? "");
  return `auth.oauthErrors.${known ? code : "unexpected"}`;
}

export function readOAuthRefusal(search: string): OAuthRefusal | null {
  const params = new URLSearchParams(search);
  const code = params.get("error_code");
  const legacy = params.get("error");
  if (!code && !legacy) return null;
  const known = (OAUTH_ERROR_CODES as readonly string[]).includes(code ?? "");
  return {
    code: known ? (code as OAuthErrorCode) : "unexpected",
    provider: params.get("provider") === "apple" ? "Apple" : "Google",
    legacyMessage: !code && legacy ? legacy : null,
  };
}
